import detention_basin_pic from '@/assets/detention-basin.png';
import green_roof_pic from '@/assets/green-roof.png';
import rain_garden_pic from '@/assets/rain-garden.png';
import swales_pic from '@/assets/swale.png';

export const SUDS_METADATA = {
  'Green roof': {
    displayName: 'Green Roof',
    primaryFunction: 'Absorb rainwater and provide insulation.',
    design: [
      'Lightweight system with a thin layer of soil (typically 60-200mm).',
      'Uses drought-resistant, low-maintenance vegetation like sedums and grasses.',
    ],
    benefits: [
      'Reduces stormwater runoff.',
      'Enhances thermal insulation and energy efficiency.',
      'Increases the lifespan of the roofing material.',
    ],
    limitations: [
      'Limited plant variety due to shallow soil depth.',
      'Requires careful design to ensure proper drainage and waterproofing.',
      'Initial installation costs can be high.',
    ],
    approxCost: '£80-£120',
    img: green_roof_pic,
  },
  Swale: {
    displayName: 'Swales',
    primaryFunction: 'Convey and infiltrate stormwater.',
    design: [
      'Shallow, vegetated channels that slow and filter runoff.',
      'Often integrated with road and pathway networks.',
    ],
    benefits: [
      'Reduces peak flows and improves water quality.',
      'Enhances site landscaping and habitat.',
    ],
    limitations: [
      'Ineffective in high clay soils without modification.',
      'Requires regular vegetation management.',
    ],
    approxCost: '£30-£60',
    img: swales_pic,
  },
  'Detention basin': {
    displayName: 'Detention Basin',
    primaryFunction: 'Temporary water storage during storms.',
    design: [
      'Dry basin that fills with water during heavy rainfall.',
      'Drains down gradually via outlet controls.',
      'Can double as open space or recreational area when dry',
    ],
    benefits: [
      'Reduces downstream flooding by attenuating peak flows',
      'Cost-effective and simple to construct',
      'Can be multi-use space for recreation when dry',
    ],
    limitations: [
      'Limited water quality improvement on its own',
      'Requires flat or gently sloping land',
      'Potential for erosion or sediment buildup at inlet/outlet points',
    ],
    approxCost: '£20-£60',
    img: detention_basin_pic,
  },
  'Rain garden': {
    displayName: 'Rain Garden',
    primaryFunction: 'Absorb and filter stormwater runoff.',
    design: [
      'Shallow, planted depressions that collect rainwater from roofs, driveways, and streets.',
      'Uses native plants that can withstand both wet and dry conditions.',
      'Typically 150-450mm below the original ground level.',
    ],
    benefits: [
      'Reduces pollution by filtering out contaminants in stormwater.',
      'Enhances biodiversity by creating habitats for pollinators and other wildlife.',
      'Helps replenish groundwater supplies through infiltration.',
      'Provides aesthetic value and can be integrated into landscaping.',
    ],
    limitations: [
      'Requires specific conditions for installation, such as proximity to drainage systems.',
      'Needs regular maintenance to ensure plant health and functionality.',
      'May not be suitable for areas with high contamination levels.',
    ],
    approxCost: '£50-£100',
    img: rain_garden_pic,
  },
};
